/*
 * The signed-out confirmation shown on every audience's sign-in screen, from
 * the "Sign in · everyone" designs (Figma UAXOnhR1ZvlsNl4diy00xX). One string
 * so the wording cannot drift between the family and school pages.
 *
 * Shown when the sign-in page is reached with ?signedout=1, which the sign-out
 * handlers add. Title only, no body, not dismissible.
 */
export const SIGNED_OUT_NOTICE =
  'You’ve signed out. Your answers are saved. If you’re using a phone or computer that other people use, close this window.';

/** The query string the sign-out handlers append to the sign-in route. */
export const SIGNED_OUT_PARAM = 'signedout=1';

export default SIGNED_OUT_NOTICE;
